// ------- Loaction-Icon ------- //
export const LocationIcon = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1902_48946)">
                <path d="M6.99996 0.5C4.2042 0.5 1.92969 2.77451 1.92969 5.57024C1.92969 9.03983 6.46708 14.1334 6.66027 14.3485C6.84172 14.5506 7.15852 14.5503 7.33965 14.3485C7.53283 14.1334 12.0702 9.03983 12.0702 5.57024C12.0702 2.77451 9.79569 0.5 6.99996 0.5ZM6.99996 8.12122C5.59334 8.12122 4.449 6.97686 4.449 5.57024C4.449 4.16362 5.59337 3.01929 6.99996 3.01929C8.40655 3.01929 9.55088 4.16365 9.55088 5.57027C9.55088 6.97689 8.40655 8.12122 6.99996 8.12122Z" fill="#4E4E4E" />
            </g>
            <defs>
                <clipPath id="clip0_1902_48946">
                    <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>

    )
}

// ------- StartFill-Icon ------- //
export const StartFillIcon = () => {
    return (
        <svg width="22" height="22" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1902_48951)">
                <path d="M12.667 17.27L18.847 21L17.207 13.97L22.667 9.24L15.477 8.63L12.667 2L9.85699 8.63L2.66699 9.24L8.12699 13.97L6.48699 21L12.667 17.27Z" fill="#E39900" />
            </g>
            <defs>
                <clipPath id="clip0_1902_48951">
                    <rect width="24" height="24" fill="white" transform="translate(0.666992)" />
                </clipPath>
            </defs>
        </svg>

    )
}
// ------- StartUnfill-Icon ------- //
export const StarUnfillIcon = () => {
    return (
        <svg width="22" height="22" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1902_48955)">
                <path d="M22.667 9.24L15.477 8.62L12.667 2L9.85699 8.63L2.66699 9.24L8.12699 13.97L6.48699 21L12.667 17.27L18.847 21L17.217 13.97L22.667 9.24ZM12.667 15.4L8.90699 17.67L9.90699 13.39L6.58699 10.51L10.967 10.13L12.667 6.1L14.377 10.14L18.757 10.52L15.437 13.4L16.437 17.68L12.667 15.4Z" fill="#E39900" />
            </g>
            <defs>
                <clipPath id="clip0_1902_48955">
                    <rect width="24" height="24" fill="white" transform="translate(0.666992)" />
                </clipPath>
            </defs>
        </svg>

    )
}